import React from 'react'
import logo from "../assets/financial-breed-images/logo.png"

function Navbar() {
    return (
        <>
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="container">
                    <a class="navbar-brand" href="/">
                        <img src={logo} alt="logo" className='img-fluid' />
                    </a>
                    {/* <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button> */}
                    <ul class="navbar-nav mb-2 mb-lg-0">
                        <li class="nav-item">
                            <a class="nav-link contactNumber" href="tel:+13073126819"><i class="fa-solid fa-phone mx-4"></i>(307)-312-6819</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    )
}

export default Navbar
